import { filter } from 'lodash';

import { isCategoryTransfer, isCategoryBalanceUpdate, categoryHasTerms } from './category.util';
import { valueContainsTerm } from './search.util.js';

export const TRANSACTION_TYPE_INCOME = 'income';
export const TRANSACTION_TYPE_EXPENSE = 'expense';

export const TRANSACTION_KIND_EVENT = 'event';
export const TRANSACTION_KIND_TRANSFER = 'transfer';
export const TRANSACTION_KIND_BALANCE_UPDATE = 'balance-update';

export function getTransactionNote(note, type, category) {
    if (note) {
        return note;
    }

    if (isCategoryTransfer(category)) {
        return category && category.name ? category.name : 'Transfer';
    }

    if (isCategoryBalanceUpdate(category)) {
        return category && category.name ? category.name : 'Balance update';
    }

    return category && category.name
        ? category.name
        : type === TRANSACTION_TYPE_INCOME
            ? 'income'
            : 'expense';
}

export function getTransactionValue(type, value) {
    return type === TRANSACTION_TYPE_INCOME ? value : -value;
}

export function transactionHasTerms(transaction, terms) {
    let note = getTransactionNote(transaction.note, transaction.type, transaction.category);
    let value = getTransactionValue(transaction.type, transaction.value);

    terms = filter(terms, (term) => !valueContainsTerm(note, term) && !transactionPriceHasTerm(value, term) && !valueContainsTerm(transaction.details, term));

    return terms.length === 0 || categoryHasTerms(transaction.category, terms);
}

export function transactionPriceHasTerm(price, term) {
    return price > 0
        ? valueContainsTerm(`+${price}`, term)
        : valueContainsTerm(`${price}`, term);
}



// WEBPACK FOOTER //
// ./src/application/util/transaction.util.js